import { FetchService } from '@fuuze/shared';
import { QueryClient } from '@tanstack/react-query';
import { getAuth } from 'firebase/auth';
import { firebaseUtil } from './utils/firebase.util';

export const fetchService = new FetchService(import.meta.env.VITE_BACKEND_URL).addRequestInterceptor(async config => {
  const token = await firebaseUtil().getIdToken();
  config.headers?.set('authorization', token || '');
  config.headers?.set('x-app-source', 'webapp');
  config.headers?.set('accept-language', getAuth().languageCode || 'en');
  return config;
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError(error, query) {
        console.log(error.message, error.stack);
        return false;
      },
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
    },
  },
});
